<template>
  <v-data-table
    fixed-header
    disable-pagination
    hide-default-footer
    disable-sort
    dense
    height="100%"
    :headers="headers"
    :items="selected"
  ></v-data-table>
</template>

<script>
const headers = [
  {
    text: 'Station',
    value: 'location_signature'
  },

  {
    text: 'Ank/Avg',
    value: 'activity_type'
  }
]

export default {
  name: 'DuwaEditModalListSelected',

  props: {
    selected: Array
  },

  data: () => ({
    headers
  })
}
</script>
